export type VerificationStage = 'session' | 'user' | 'identity';
export type VerificationFailure = 'retryable' | 'invalid' | 'denied' | 'unavailable';

// Classify structured failures, never by a server's free-form denial message.
// Unknown failures remain blocked and require a deliberate retry.
export function verificationFailure(error: unknown, stage: VerificationStage): VerificationFailure {
  const value = error as { code?: string; status?: number; name?: string; message?: string } | null;
  const code = value?.code;
  if (code === '42501' || code === 'identity_missing' || code === 'admin_required') return 'denied';
  if (code && ['bad_jwt', 'jwt_expired', 'session_not_found', 'session_expired',
    'refresh_token_not_found', 'refresh_token_already_used', 'invalid_refresh_token',
    'user_not_found', 'user_banned', 'session_missing', 'identity_changed', 'PGRST301', 'PGRST302', 'PGRST303'].includes(code)) return 'invalid';
  if (value?.status === 401) return 'invalid';
  if (value?.status === 403) return stage === 'identity' ? 'denied' : 'invalid';
  if (value?.name === 'AuthRetryableFetchError' || value?.status === 0 || value?.status === 408 ||
    value?.status === 429 || (typeof value?.status === 'number' && value.status >= 500 && value.status <= 599) ||
    (value?.name === 'TypeError' && /failed to fetch|fetch failed|network|load failed/i.test(value.message || '')) ||
    value?.name === 'NetworkError') return 'retryable';
  return 'unavailable';
}
